import React from 'react';

import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSearchParams } from 'react-router-dom';

import OhsUserLocalServices from 'user/OhsUserLocalServices';
import { TierType } from 'global-services/constants/OhsObject';
import { ModuleUrl } from 'global-services/constants/OhsRoutes';

import getOhsBreadcrumbsNameAndRef from './OhsBreadcrumbsServices';
import OhsBreadcrumbDocumentsFolderView from './OhsBreadcrumbDocumentsFolderView';

const useStyles = makeStyles()((theme: Theme) => ({
  link: {
    display: 'flex',
    fontSize: 'small',
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
}));

export default function OhsBreadcrumbs() {
  const { classes } = useStyles();
  const [searchParams] = useSearchParams();
  const user = OhsUserLocalServices.getLocalOhsUser();

  const ohsBreadcrumbsNameAndRef = getOhsBreadcrumbsNameAndRef({ searchParams });

  const { pathname } = window.location;
  const modulePath = pathname.split('/')[1];

  const withFullModuleLinkAccess = () => {
    if (modulePath === ModuleUrl.Action) return true;
    return user && user.tier.type !== TierType.T5;
  };

  const withFullViewLinkAccess = () => {
    return user && user.tier.type !== TierType.T5;
  };

  return (
    <Breadcrumbs separator={<NavigateNextIcon />} aria-label="breadcrumb">
      {ohsBreadcrumbsNameAndRef.homeRef && (
        <Link href={ohsBreadcrumbsNameAndRef.homeRef.href} className={classes.link}>
          Home
        </Link>
      )}

      {/* Module */}
      {withFullModuleLinkAccess() && ohsBreadcrumbsNameAndRef.moduleRef && (
        <Link href={ohsBreadcrumbsNameAndRef.moduleRef.href} className={classes.link}>
          {ohsBreadcrumbsNameAndRef.moduleRef.name}
        </Link>
      )}

      {/* View */}
      {withFullViewLinkAccess() && ohsBreadcrumbsNameAndRef.parentOperationRef && (
        <Link href={ohsBreadcrumbsNameAndRef.parentOperationRef.href} className={classes.link}>
          {ohsBreadcrumbsNameAndRef.parentOperationRef.name}
        </Link>
      )}

      {/* Sign-off / Completed / Action */}
      {ohsBreadcrumbsNameAndRef.leafName && (
        <Typography className={classes.link}>{ohsBreadcrumbsNameAndRef.leafName.name}</Typography>
      )}

      {modulePath === ModuleUrl.Documents && <OhsBreadcrumbDocumentsFolderView />}
    </Breadcrumbs>
  );
}
